if (!customElements.get("collections-filtering")) {
  class CollectionsFiltering extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      this.button = this.querySelector('button[type="submit"]');
      this.selects = Array.from(this.querySelectorAll("select.dropdown-filter"));

      // Названия полей согласно нашему JSON
      this.fields = ['Make', 'Model', 'Year'];
      this.vehicleData = [];
      this.customDropdowns = [];

      this.init();
    }

    async init() {
      try {
        // Inject only essential styles for overscroll isolation
        const style = document.createElement('style');
        style.textContent = `
          .dropdown-items-container { 
            overscroll-behavior: contain !important; 
            -webkit-overflow-scrolling: touch;
          }
        `;
        document.head.appendChild(style);

        await this.loadData();
        this.createCustomDropdowns();
        this.setupEventListeners();
        this.populateFirstDropdown();
      } catch (error) {
        console.error("Failed to initialize vehicle filter:", error);
      }
    }

    async loadData() {
      const url = window.VEHICLE_DATA_URL || '/assets/vehicle-data.json';

      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Could not load vehicle-data.json (status: ${response.status})`);
        }
        this.vehicleData = await response.json();
        console.log(`✓ Loaded ${this.vehicleData.length} vehicle records`);
      } catch (error) {
        console.error('✗ Failed to load vehicle data:', error);
        alert('Failed to load vehicle database. Please refresh the page.');
        throw error;
      }
    }

    createCustomDropdowns() {
      this.selects.forEach((select, index) => {
        const formGroup = select.closest('.form-group');

        // Create custom dropdown wrapper
        const customDropdown = document.createElement('div');
        customDropdown.className = 'custom-dropdown';
        customDropdown.dataset.index = index;

        // Create selected value display
        const selectedDisplay = document.createElement('div');
        selectedDisplay.className = 'custom-dropdown-selected';
        selectedDisplay.textContent = select.querySelector('option.default')?.textContent || 'Select...';

        // Create dropdown list container
        const dropdownList = document.createElement('div');
        dropdownList.className = 'custom-dropdown-list';

        // Add elements to custom dropdown
        customDropdown.appendChild(selectedDisplay);
        customDropdown.appendChild(dropdownList);

        // Hide original select and insert custom dropdown
        select.style.display = 'none';
        formGroup.appendChild(customDropdown);

        // Store reference
        this.customDropdowns[index] = {
          wrapper: customDropdown,
          display: selectedDisplay,
          list: dropdownList,
          select: select
        };

        // Click handler for opening/closing
        selectedDisplay.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleDropdown(index);
        });

        // Click handler for backdrop (mobile)
        customDropdown.addEventListener('click', (e) => {
          // Only close if clicking on backdrop (::before pseudo-element area)
          if (e.target === customDropdown && customDropdown.classList.contains('open')) {
            this.closeAllDropdowns();
          }
        });
      });

      // Close dropdowns when clicking outside
      document.addEventListener('click', () => {
        this.closeAllDropdowns();
      });
    }

    toggleDropdown(index) {
      const dropdown = this.customDropdowns[index];
      const isOpen = dropdown.wrapper.classList.contains('open');

      // Close all dropdowns first
      this.closeAllDropdowns();

      // Open this dropdown if it was closed
      if (!isOpen && !dropdown.select.disabled) {
        dropdown.wrapper.classList.add('open');

        // Auto-focus search input (ONLY on desktop) and adjust position
        setTimeout(() => {
          if (window.innerWidth >= 990) {
            const searchInput = dropdown.list.querySelector('.dropdown-search-input');
            if (searchInput) {
              searchInput.focus();
            }
          }

          // Adjust dropdown position if needed
          this.adjustDropdownPosition(index);
        }, 100);
      }
    }

    adjustDropdownPosition(index) {
      const dropdown = this.customDropdowns[index];
      const list = dropdown.list;
      const wrapper = dropdown.wrapper;

      // On mobile, dropdown is fixed at bottom - no adjustment needed
      if (window.innerWidth < 990) {
        // Reset any inline styles
        list.style.top = '';
        list.style.bottom = '';
        list.style.transform = '';
        list.style.left = '';
        list.style.right = '';
        wrapper.classList.remove('dropdown-opens-upward');
        return;
      }

      // Check if we're in vertical filters section
      const isVerticalFilters = wrapper.closest('.section-vertical-filters-form-wrap');

      if (isVerticalFilters) {
        // For vertical filters: use absolute positioning (CSS handles it)
        // Just check vertical space
        const rect = wrapper.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const spaceBelow = viewportHeight - rect.bottom;
        const spaceAbove = rect.top;
        const listHeight = list.offsetHeight;

        // Reset any horizontal shifts/transforms
        list.style.left = '';
        list.style.right = '';
        list.style.transform = '';

        // Vertical positioning
        if (spaceBelow < listHeight && spaceAbove > listHeight) {
          // Open upward
          list.style.top = 'auto';
          list.style.bottom = 'calc(100% + 0.5rem)';
          wrapper.classList.add('dropdown-opens-upward');
        } else {
          // Open downward
          list.style.top = 'calc(100% + 0.5rem)';
          list.style.bottom = 'auto';
          wrapper.classList.remove('dropdown-opens-upward');
        }

      } else {
        // Standard filters: use absolute positioning
        const rect = wrapper.getBoundingClientRect();
        const listHeight = list.offsetHeight;
        const viewportHeight = window.innerHeight;
        const spaceBelow = viewportHeight - rect.bottom;
        const spaceAbove = rect.top;

        // Reset fixed positioning styles
        list.style.left = '';
        list.style.right = '';

        // If not enough space below but enough above - open upward
        if (spaceBelow < listHeight && spaceAbove > listHeight) {
          list.style.top = 'auto';
          list.style.bottom = 'calc(100% + 0.5rem)';
          wrapper.classList.add('dropdown-opens-upward');
        } else {
          list.style.top = 'calc(100% + 0.5rem)';
          list.style.bottom = 'auto';
          wrapper.classList.remove('dropdown-opens-upward');
        }
      }
    }

    closeAllDropdowns() {
      this.customDropdowns.forEach(dropdown => {
        dropdown.wrapper.classList.remove('open');
      });
    }

    groupByAlphabet(items) {
      const grouped = {};

      items.forEach(item => {
        const firstChar = item.charAt(0).toUpperCase();
        if (!grouped[firstChar]) {
          grouped[firstChar] = [];
        }
        grouped[firstChar].push(item);
      });

      return grouped;
    }

    renderDropdownList(index, options) {
      const dropdown = this.customDropdowns[index];
      const list = dropdown.list;

      // Clear existing content
      list.innerHTML = '';

      // Add search box
      const searchBox = document.createElement('div');
      searchBox.className = 'dropdown-search-box';
      searchBox.innerHTML = `
        <input 
          type="text" 
          class="dropdown-search-input" 
          placeholder="Search..." 
          autocomplete="off"
        />
      `;
      list.appendChild(searchBox);

      // Create items container with grid
      const itemsContainer = document.createElement('div');
      itemsContainer.className = 'dropdown-items-container';

      // Group options by alphabet
      const grouped = this.groupByAlphabet(options);
      const letters = Object.keys(grouped).sort();

      // Create alphabet groups
      letters.forEach(letter => {
        // Create group wrapper
        const group = document.createElement('div');
        group.className = 'dropdown-alphabet-group';

        // Add alphabet header
        const header = document.createElement('div');
        header.className = 'dropdown-alphabet-header';
        header.textContent = letter;
        group.appendChild(header);

        // Add items for this letter
        grouped[letter].forEach(option => {
          const item = document.createElement('div');
          item.className = 'dropdown-item';
          item.textContent = option;
          item.dataset.value = option;
          item.dataset.searchText = option.toLowerCase();

          item.addEventListener('click', (e) => {
            e.stopPropagation();
            this.selectOption(index, option);
          });

          group.appendChild(item);
        });

        itemsContainer.appendChild(group);
      });

      list.appendChild(itemsContainer);

      // Setup search functionality
      const searchInput = searchBox.querySelector('.dropdown-search-input');
      searchInput.addEventListener('input', (e) => {
        const searchTerm = e.target.value.toLowerCase();
        const items = itemsContainer.querySelectorAll('.dropdown-item');
        const groups = itemsContainer.querySelectorAll('.dropdown-alphabet-group');

        groups.forEach(group => {
          const groupItems = group.querySelectorAll('.dropdown-item');
          let hasVisibleItems = false;

          groupItems.forEach(item => {
            const text = item.dataset.searchText;
            if (text.includes(searchTerm)) {
              item.classList.remove('hidden');
              hasVisibleItems = true;
            } else {
              item.classList.add('hidden');
            }
          });

          // Hide group if no visible items
          if (hasVisibleItems) {
            group.style.display = '';
          } else {
            group.style.display = 'none';
          }
        });
      });

      // Focus search input when dropdown opens
      searchInput.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }

    selectOption(index, value) {
      const dropdown = this.customDropdowns[index];

      // Update hidden select
      dropdown.select.value = value;

      // Update display
      dropdown.display.textContent = value;
      dropdown.wrapper.classList.add('has-value');

      // Close dropdown
      this.closeAllDropdowns();

      // Trigger change event
      const event = new Event('change', { bubbles: true });
      dropdown.select.dispatchEvent(event);
    }

    setupEventListeners() {
      this.form.addEventListener("submit", (event) => {
        event.preventDefault();
        this.redirectToCollection();
      });

      this.selects.forEach((select, index) => {
        select.addEventListener("change", () => this.onDropdownChange(index));
      });
    }

    populateFirstDropdown() {
      const firstSelect = this.selects[0];
      if (!firstSelect) return;

      const uniqueMakes = [...new Set(this.vehicleData.map(item => item.Make))].sort();
      this.fillSelect(firstSelect, uniqueMakes, 0);
      firstSelect.disabled = false;
      firstSelect.closest(".form-group").classList.remove("disabled");
      this.customDropdowns[0].wrapper.classList.remove('disabled');
    }

    onDropdownChange(changedIndex) {
      // 1. Очистить и заблокировать все последующие селекты
      for (let i = changedIndex + 1; i < this.selects.length; i++) {
        const select = this.selects[i];
        this.clearSelect(select, i);
        select.disabled = true;
        select.closest(".form-group").classList.add("disabled");
        this.customDropdowns[i].wrapper.classList.add('disabled');
        this.customDropdowns[i].wrapper.classList.remove('has-value');
      }

      // 2. Активировать кнопку поиска только если выбраны все 3 параметра
      this.updateButtonState();

      // 3. Если это не последний селект, заполнить следующий
      if (changedIndex < this.selects.length - 1) {
        this.populateNextDropdown(changedIndex);
      }
    }

    populateNextDropdown(currentIndex) {
      const nextIndex = currentIndex + 1;
      const nextSelect = this.selects[nextIndex];
      const nextField = this.fields[nextIndex];

      // Фильтруем данные на основе всех предыдущих выборов
      let filteredData = this.vehicleData;
      for (let i = 0; i <= currentIndex; i++) {
        const val = this.selects[i].value;
        const field = this.fields[i];
        filteredData = filteredData.filter(item => item[field] === val);
      }

      const options = [...new Set(filteredData.map(item => item[nextField]))].sort();
      this.fillSelect(nextSelect, options, nextIndex);

      if (options.length > 0) {
        nextSelect.disabled = false;
        nextSelect.closest(".form-group").classList.remove("disabled");
        this.customDropdowns[nextIndex].wrapper.classList.remove('disabled');

        // Auto-open next dropdown
        setTimeout(() => {
          this.toggleDropdown(nextIndex);
        }, 300);
      }
    }

    fillSelect(select, options, index) {
      this.clearSelect(select, index);
      options.forEach(opt => {
        const option = document.createElement('option');
        option.value = opt;
        option.textContent = opt;
        select.appendChild(option);
      });

      // Render custom dropdown list
      this.renderDropdownList(index, options);
    }

    clearSelect(select, index) {
      const defaultOption = select.querySelector("option.default");
      select.innerHTML = '';
      if (defaultOption) {
        select.appendChild(defaultOption);
        defaultOption.selected = true;
      }

      // Reset custom dropdown display
      if (this.customDropdowns[index]) {
        this.customDropdowns[index].display.textContent = defaultOption?.textContent || 'Select...';
        this.customDropdowns[index].list.innerHTML = '';
      }
    }

    updateButtonState() {
      // Enable button as soon as the first parameter (Make) is selected
      const firstSelected = this.selects[0].value && this.selects[0].value !== "";
      this.button.disabled = !firstSelected;
    }

    redirectToCollection() {
      const make = this.selects[0].value;
      const model = this.selects[1].value;
      const year = this.selects[2].value;

      // Determine collection based on Make
      const collectionSlug = this.getCollectionSlug(make);

      // Build URL with Shopify metafield filter parameters
      const params = new URLSearchParams();
      params.set('sort_by', 'best-selling'); // Default sorting

      // Only add filter parameters if they are selected
      if (make) params.set('filter.p.m.custom.vehicle_make', make);
      if (model) params.set('filter.p.m.custom.vehicle_model', model);
      if (year) params.set('filter.p.m.custom.vehicle_year_s', year);

      const collectionUrl = `/collections/${collectionSlug}?${params.toString()}`;

      console.log(`✓ Redirecting to collection: ${collectionUrl}`);
      window.location.href = collectionUrl;
    }

    getCollectionSlug(make) {
      if (!make) return 'all';

      // Dynamic slug generation: "Lamborghini" -> "lamborghini-collection"
      // "Aston Martin" -> "aston-martin-collection"
      return make.toLowerCase().trim()
        .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric with hyphens
        .replace(/^-+|-+$/g, '')    // Remove leading/trailing hyphens
        + '-collection';
    }

  }

  customElements.define("collections-filtering", CollectionsFiltering);
}
